export default __webpack_public_path__ + "static/media/i_success_new.c60e2c44.svg";